import React from 'react';//, { Component }
//import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';//, Link, HashRouter as Router, 
import Menu from './Menu';
import { Dashboard } from './Dashboard';
import ContentEditor from '../components/Content/ContentEditor';
//import Preview from './Preview';

export const ProjectLayout = ({ client, project }) => (
    <div>
        <Menu className="sidebar sidebar-inverse pr-0 pl-0" client={client} project={project} />
        <div className="sidebar-offset container-fluid">
            <Switch>
                <Route exact={true} path="/:client/:project" component={Dashboard} />
                
                <Route path="/:client/:project/:id" component={({ match }) => (
                    <ContentEditor
                        client={match.params.client}
                        project={match.params.project}
                        id={match.params.id} />)} />
            </Switch>
        </div>
    </div>
)